import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceDashboardService {

  
  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getagentMaintenaceList() {

    const API_URL: string = environment.baseUrl + environment.apis.getagentMaintenaceList;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}
